/**
 * Legacy GlcodesApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.glcodesApi`) keep resolving.
 *
 * The actual GlcodesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/glcodes/glcodes-api.service.ts
 */
angular.module("acme.common.service.glcodesApi", [
  "acme.common.factory.QueryStringBuilder",
]);
